
<div mat-dialog-title
  >{{warningsData.responseData?.length > 1 ? "Move Multiple Securities" : "Move Security into a Group"}}<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
  <mat-dialog-content>
    @if (warningsData?.responseData?.length <= 1) {
      <div>
        <!--        <mat-card class="block">-->
        <!--            <mat-card-title style="font-family: Arial;font-size: 13px;font-weight:bold;color: #000000;white-space: pre-line;">-->
        <!--                {{warningsData?.responseData[0]?.securitySymbol}} selected-->
      <!--            </mat-card-title>-->
    <!--        </mat-card>-->
    <div>
      @if (warningsData?.hasCashSecurity) {
        <div>
          <mat-card class="block error">
            <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">"$CASH" cannot be moved</mat-card-title>
          </mat-card>
        </div>
      }
      @if (warningsData?.groupSecurities?.length > 0) {
        <div>
          <mat-card class="block error">
            <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
              {{warningsData?.responseData[0]?.securitySymbol}} is a group security, and cannot be moved into
              another group security.
            </mat-card-title>
          </mat-card>
        </div>
      }
      @if (warningsData?.smaSecurities?.length > 0) {
        <div>
          <mat-card class="block error">
            <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
              {{warningsData?.responseData[0]?.securitySymbol}} is a SMA security, and cannot be moved into
              another group security.
            </mat-card-title>
          </mat-card>
        </div>
      }
      @if (warningsData?.externalSecurities?.length > 0) {
        <div>
          <mat-card class="block error">
            <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
              {{warningsData?.responseData[0]?.securitySymbol}} is an external security, and cannot be moved into another group security.
            </mat-card-title>
          </mat-card>
        </div>
      }
      @if (!(warningsData?.hasCashSecurity ||(warningsData?.groupSecurities?.length > 0) ||
        (warningsData?.smaSecurities?.length > 0) || (warningsData?.externalSecurities?.length > 0))) {
        <div>
          <mat-card class="block info">
            <mat-card-title style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
              iRebal will review the selected security to see if it is in use elsewhere in the application before
              being moved.
            </mat-card-title>
          </mat-card>
          <p>Click "Continue" to begin the review.</p>
        </div>
      }
    </div>
  </div>
}
@if (warningsData?.responseData?.length > 1) {
  <div>
    <mat-card class="block">
      <mat-card-title style="white-space: pre-line;">You're about to take an action on multiple securities.
      </mat-card-title>
    </mat-card>
    <div>
      @if (warningsData?.hasCashSecurity) {
        <div>
          <mat-card class="block warn">
            <mat-card-title
              style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
              "$CASH" cannot be moved
            </mat-card-title>
            <p>Although selected, it will not be included in the action you are about to take.</p>
          </mat-card>
        </div>
      }
      @if (warningsData?.groupSecurities?.length > 0) {
        <div>
          @if (warningsData?.groupSecurities?.length === 1) {
            <div>
              <mat-card class="block warn">
                <mat-card-title
                  style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                  {{warningsData?.groupSecurities[0]?.securitySymbol}} is a group security, and cannot be
                  moved into another group security.
                </mat-card-title>
                <p>Although selected, it will not be included in the action you are about to take.</p>
              </mat-card>
            </div>
          }
          @if (warningsData?.groupSecurities?.length > 1) {
            <div>
              <mat-card class="block warn">
                <mat-card-title
                  style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                  {{getCommaSeparatedList(warningsData?.groupSecurities)}} are group securities, and cannot be
                  moved in to another group security.
                </mat-card-title>
                <p>Although selected, they will not be included in the action you are about to take.</p>
              </mat-card>
            </div>
          }
        </div>
      }
      @if (warningsData?.smaSecurities?.length > 0) {
        <div>
          @if (warningsData?.smaSecurities?.length === 1) {
            <div>
              <mat-card class="block warn">
                <mat-card-title
                  style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                  {{warningsData?.smaSecurities[0]?.securitySymbol}} is a SMA security, and cannot be moved in
                  to another group security.
                </mat-card-title>
                <p>Although selected, it will not be included in the action you are about to take.</p>
              </mat-card>
            </div>
          }
          @if (warningsData?.smaSecurities?.length > 1) {
            <div>
              <mat-card class="block warn">
                <mat-card-title
                  style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                  {{getCommaSeparatedList(warningsData?.smaSecurities)}} are SMA, and cannot be moved into
                  another group security.
                </mat-card-title>
                <p>Although selected, they will not be included in the action you are about to take.</p>
              </mat-card>
            </div>
          }
        </div>
      }
      @if (warningsData?.externalSecurities?.length > 0) {
        <div>
          @if (warningsData?.externalSecurities?.length === 1) {
            <div>
              <mat-card class="block warn">
                <mat-card-title
                  style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                  {{warningsData?.externalSecurities[0]?.securitySymbol}} is an external security, and cannot
                  be
                  moved into another group security.
                </mat-card-title>
                <p>Although selected, it will not be included in the action you are about to take.</p>
              </mat-card>
            </div>
          }
          @if (warningsData?.externalSecurities?.length > 1) {
            <div>
              <mat-card class="block warn">
                <mat-card-title
                  style="font-family: Arial;font-size: 13px;color: #000000;white-space: pre-line;">
                  {{getCommaSeparatedList(warningsData?.externalSecurities)}} are external securities, and
                  cannot
                  be moved into another group security.
                </mat-card-title>
                <p>Although selected, they will not be included in the action you are about to take.</p>
              </mat-card>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary grey">Cancel</button>
  <button class="btn-medium-primary green" (click)="onContinue()" [disabled]="warningsData?.processArray?.length <= 0">Continue</button>
</mat-dialog-actions>
